import script from "./DownloadViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadViewer.vue?vue&type=script&setup=true&lang=ts"

import "./DownloadViewer.vue?vue&type=style&index=0&id=0cad247c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cad247c"]])

export default __exports__